module.exports = __webpack_public_path__ + "static/media/NorthWestTelegraph-devicecomp-min.23d81c0a.png";